import React from 'react';
import './BetaPricingPage.css';

interface PaymentLinks {
  single: string;
  starter: string;
  growth: string;
  professional: string;
}

const PricingPage: React.FC = () => {
  // Replace these with your actual Stripe payment links
  const paymentLinks: PaymentLinks = {
    single: 'https://buy.stripe.com/eVa6rO1On7iM0vK7ss',
    starter: 'https://buy.stripe.com/28o4jGeB97iM3HW8wx',
    growth: 'https://buy.stripe.com/6oE9E0fFd6eIbao002',
    professional: 'https://buy.stripe.com/4gwg2o2Sr6eI2DSeUX'
  };

  return (
    <div className="pricing-page-wrapper">
      <div className="pricing-container">
        <div className="pricing-header">
          <h1>Select Your Pitch Package</h1>
          <p className="pricing-subtitle">Streamline your DSP pitching process with the package that fits your needs</p>
        </div>

        <div className="pricing-tiers">
          <div className="pricing-card">
            <div className="pricing-card-header">
              <h2>Single Pitch</h2>
              <div className="pricing-price">
                <span className="price">$15</span>
              </div>
            </div>
            <div className="pricing-features">
              <div className="pricing-feature-item">
                <div className="feature-value">1</div>
                <div className="feature-name">Pitch</div>
              </div>
              <p className="pricing-description">Great for low-frequency release schedules or first-time users.</p>
            </div>
            <a 
              href={paymentLinks.single} 
              className="btn-purchase"
            >
              Purchase Now
            </a>
          </div>

          <div className="pricing-card">
            <div className="pricing-card-header">
              <h2>Starter Pack</h2>
              <div className="pricing-price">
                <span className="price">$75</span>
              </div>
            </div>
            <div className="pricing-features">
              <div className="pricing-feature-item">
                <div className="feature-value">5</div>
                <div className="feature-name">Pitches</div>
              </div>
              <p className="pricing-description">Perfect for labels with small rosters starting with Cadence IO.</p>
            </div>
            <a 
              href={paymentLinks.starter} 
              className="btn-purchase"
            >
              Purchase Now
            </a>
          </div>

          <div className="pricing-card">
            <div className="pricing-card-header">
              <h2>Growth Pack</h2>
              <div className="pricing-price">
                <span className="price">$215</span>
              </div>
            </div>
            <div className="pricing-features">
              <div className="pricing-feature-item">
                <div className="feature-value">15</div>
                <div className="feature-name">Pitches</div>
              </div>
              <p className="pricing-description">Ideal for labels with a growing roster of artists and regular releases.</p>
            </div>
            <a 
              href={paymentLinks.growth} 
              className="btn-purchase"
            >
              Purchase Now
            </a>
          </div>

          <div className="pricing-card">
            <div className="pricing-card-header">
              <h2>Professional Pack</h2>
              <div className="pricing-price">
                <span className="price">$340</span>
              </div>
            </div>
            <div className="pricing-features">
              <div className="pricing-feature-item">
                <div className="feature-value">25</div>
                <div className="feature-name">Pitches</div>
              </div>
              <p className="pricing-description">Designed for established labels with multiple artists and frequent releases.</p>
            </div>
            <a 
              href={paymentLinks.professional} 
              className="btn-purchase"
            >
              Purchase Now
            </a>
          </div>
        </div>

        <div className="pricing-footer">
          <p>Need a custom solution? Contact your account manager for more options.</p>
        </div>
      </div>
    </div>
  );
};

export default PricingPage;